import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var Wrapper = /*#__PURE__*/_styled("div", true ? {
  target: "ehpzz1l0"
} : {
  target: "ehpzz1l0",
  label: "Wrapper"
})(true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : {
  name: "1flj9lk",
  styles: "text-align:left",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvdGVtcGxhdGVzL0Zvcm1zL1NpZ25VcEZvcm0vU2lnbnVwRm9ybS52aWV3cy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWlDIiwiZmlsZSI6Ii93b3JrZGlyL2xpYnMvdGVtcGxhdGVzL0Zvcm1zL1NpZ25VcEZvcm0vU2lnbnVwRm9ybS52aWV3cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuZXhwb3J0IGNvbnN0IFdyYXBwZXIgPSBzdHlsZWQuZGl2YFxuICB0ZXh0LWFsaWduOiBsZWZ0O1xuYFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});